/* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKTcp%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D%0A._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._23rrnHoacQ%7Btransition%3Abackground%20.1s%20ease-out%7D%0A._2V7sgOdnbC%7Bborder-width%3A0%7D%0A._4c065UgVvo%7Bpadding-block%3Avar(--ds-space-075%2C6px)%7D%0A._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._39xV02IZbP%7Bwidth%3Aauto%7D%0A._1EqgXlN91d%7Bmax-width%3A100%25%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._0hPCNLQame%7Balign-items%3Abaseline%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._17lj8p1Y8M%7B-moz-column-gap%3Avar(--ds-space-050%2C4px)%3Bcolumn-gap%3Avar(--ds-space-050%2C4px)%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._0jFU0VZ49V%7Bheight%3A2rem%7D%0A._1kk5Tkf7mX%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D%0A._03SyCP8HPE%7Bpadding-inline-end%3Avar(--ds-space-150%2C9pt)%7D%0A._0LQT5E8HPE%7Bpadding-inline-start%3Avar(--ds-space-150%2C9pt)%7D%0A._2fwxA5DIqT%7Btext-align%3Acenter%7D%0A._1RrJLit2nV%7Bvertical-align%3Amiddle%7D%0A._2Gfj6iOLYo%3Aafter%7Bborder-radius%3Ainherit%7D%0A._0EnhYgPgdg%3Aafter%7Binset%3Avar(--ds-space-0%2C0)%7D%0A._4lwhQT6wH8%3Aafter%7Bborder-style%3Asolid%7D%0A._0dpm39NvrM%3Aafter%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._2tbAUcYbGa%3Aafter%7Bpointer-events%3Anone%7D%0A._2WYcYGWVPG%3Aafter%7Bposition%3Aabsolute%7D%0A._23rrnHyKLB%7Btransition%3Avar(--ds-button-hovered%2Cbackground-color%20border-color%20.15s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._3sFUREiSCN%3Aactive%7Btransition%3Avar(--ds-button-pressed%2Cbackground-color%20border-color%20.15s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._00uqCY98eZ%7Btext-decoration-color%3AcurrentColor%7D%0A._3xtjKNYbGa%7Btext-decoration-line%3Anone%7D%0A._0H9qDF6wH8%7Btext-decoration-style%3Asolid%7D%0A._32C2rk98eZ%3Afocus%7Btext-decoration-color%3AcurrentColor%7D%0A._0i9AWAYbGa%3Afocus%7Btext-decoration-line%3Anone%7D%0A._0mm6KQ6wH8%3Afocus%7Btext-decoration-style%3Asolid%7D%0A._0DCa9D98eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D%0A._3932vvYbGa%3Ahover%7Btext-decoration-line%3Anone%7D%0A._02cRtH6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D%0A._3WzCGi98eZ%3Aactive%7Btext-decoration-color%3AcurrentColor%7D%0A._0NqVRtYbGa%3Aactive%7Btext-decoration-line%3Anone%7D%0A._3BKYwu6wH8%3Aactive%7Btext-decoration-style%3Asolid%7D%0A._0wOv4Qsyl5%7Bcursor%3Anot-allowed%7D%0A._1UtDYzot27%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._0clgaMot27%3Ahover%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._0CMRbkot27%3Aactive%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._0KLXruVrZW%7Bbackground-color%3Avar(--ds-background-disabled%2C%230515240f)%7D%0A._1eOmH6VrZW%3Ahover%7Bbackground-color%3Avar(--ds-background-disabled%2C%230515240f)%7D%0A._3gzVzLVrZW%3Aactive%7Bbackground-color%3Avar(--ds-background-disabled%2C%230515240f)%7D%0A._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._4c065UFQfX%7Bpadding-block%3Avar(--ds-space-025%2C2px)%7D%0A._0jFU0V9DVM%7Bheight%3A1.5rem%7D%0A._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._0wOv4Q2mtD%7Bcursor%3Aprogress%7D%0A._39xV02Z49V%7Bwidth%3A2rem%7D%0A._03SyCPPgdg%7Bpadding-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._0LQT5EPgdg%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._39xV029DVM%7Bwidth%3A1.5rem%7D%0A._17lj8pgVvo%7B-moz-column-gap%3Avar(--ds-space-075%2C6px)%3Bcolumn-gap%3Avar(--ds-space-075%2C6px)%7D%0A._13yjolgtVO%3Afocus-visible%7Bz-index%3A100%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._1ZB6UyPgdg%7Binset-block-end%3Avar(--ds-space-0%2C0)%7D%0A._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D%0A._1OKFqYPgdg%7Binset-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._3iC0zdPgdg%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._39xV02oWWg%7Bwidth%3A24px%7D%0A._0KLXru66of%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D%0A._03SyCPgVvo%7Bpadding-inline-end%3Avar(--ds-space-075%2C6px)%7D%0A._0LQT5EgVvo%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D%0A._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._0z8nYC9r67%3Aafter%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._0GBAIrogpp%3Aafter%7Bcontent%3A%22%22%7D%0A._2nTuUYZpcK%3Avisited%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._10n1R5ZpcK%3Afocus%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._0clgaMZpcK%3Ahover%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._0CMRbkZpcK%3Aactive%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._1eOmH6o126%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D%0A._3gzVzLN4oS%3Aactive%7Bbackground-color%3Avar(--ds-background-neutral-subtle-pressed%2C%230b120e24)%7D%0A._0KLXrujOvk%7Bbackground-color%3Atransparent%7D%0A._0z8nYChQC5%3Aafter%7Bborder-color%3Avar(--ds-border-disabled%2C%230515240f)%7D%0A._1eOmH6jOvk%3Ahover%7Bbackground-color%3Atransparent%7D%0A._3gzVzLjOvk%3Aactive%7Bbackground-color%3Atransparent%7D%0A._0KLXruDM2k%7Bbackground-color%3Avar(--ds-background-brand-bold%2C%231868db)%7D%0A._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._2nTuUYe5R3%3Avisited%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._10n1R5e5R3%3Afocus%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._0clgaMe5R3%3Ahover%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._0CMRbke5R3%3Aactive%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._1eOmH6hmrj%3Ahover%7Bbackground-color%3Avar(--ds-background-brand-bold-hovered%2C%231558bc)%7D%0A._3gzVzLczkD%3Aactive%7Bbackground-color%3Avar(--ds-background-brand-bold-pressed%2C%23144794)%7D%0A._0KLXruWwnm%7Bbackground-color%3Avar(--ds-rovo-background-brand-bold%2C%23000)%7D%0A._1eOmH63nEM%3Ahover%7Bbackground-color%3Avar(--ds-rovo-background-brand-bold-hovered%2C%231e1f21)%7D%0A._3gzVzLjYGY%3Aactive%7Bbackground-color%3Avar(--ds-rovo-background-brand-bold-pressed%2C%23292a2e)%7D%0A._0KLXruKLKE%7Bbackground-color%3Avar(--ds-background-warning-bold%2C%23fbc828)%7D%0A._1UtDYzVW6T%7Bcolor%3Avar(--ds-text-warning-inverse%2C%23292a2e)%7D%0A._2nTuUYVW6T%3Avisited%7Bcolor%3Avar(--ds-text-warning-inverse%2C%23292a2e)%7D%0A._10n1R5VW6T%3Afocus%7Bcolor%3Avar(--ds-text-warning-inverse%2C%23292a2e)%7D%0A._0clgaMVW6T%3Ahover%7Bcolor%3Avar(--ds-text-warning-inverse%2C%23292a2e)%7D%0A._0CMRbkVW6T%3Aactive%7Bcolor%3Avar(--ds-text-warning-inverse%2C%23292a2e)%7D%0A._1eOmH6OCpk%3Ahover%7Bbackground-color%3Avar(--ds-background-warning-bold-hovered%2C%23fca700)%7D%0A._3gzVzLSN2W%3Aactive%7Bbackground-color%3Avar(--ds-background-warning-bold-pressed%2C%23f68909)%7D%0A._0KLXruqsXs%7Bbackground-color%3Avar(--ds-background-danger-bold%2C%23c9372c)%7D%0A._1eOmH6EISo%3Ahover%7Bbackground-color%3Avar(--ds-background-danger-bold-hovered%2C%23ae2e24)%7D%0A._3gzVzLL5fL%3Aactive%7Bbackground-color%3Avar(--ds-background-danger-bold-pressed%2C%23872821)%7D%0A._0KLXruqjHC%7Bbackground-color%3Avar(--ds-background-discovery-bold%2C%23964ac0)%7D%0A._1eOmH6nIkF%3Ahover%7Bbackground-color%3Avar(--ds-background-discovery-bold-hovered%2C%23803fa5)%7D%0A._3gzVzLSHT5%3Aactive%7Bbackground-color%3Avar(--ds-background-discovery-bold-pressed%2C%23673286)%7D%0A._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._1UtDYzjTy9%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._0z8nYCrzt2%3Aafter%7Bborder-color%3Avar(--ds-border-selected%2C%231868db)%7D%0A._2nTuUYjTy9%3Avisited%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._10n1R5jTy9%3Afocus%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._0clgaMjTy9%3Ahover%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._0CMRbkjTy9%3Aactive%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._42Yu6BiZR3%7Bz-index%3A2%7D%0A._1eOmH6sumd%3Ahover%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D%0A._3gzVzLXsxn%3Aactive%7Bbackground-color%3Avar(--ds-background-selected-pressed%2C%238fb8f6)%7D%0A._1eOmH6Y9q9%3Ahover%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._3gzVzLY9q9%3Aactive%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._0KLXrunl7T%7Bbackground-color%3Avar(--ds-background-brand-subtlest%2C%23e9f2fe)%7D%0A._1UtDYzGaer%7Bcolor%3Avar(--ds-text-brand%2C%231868db)%7D%0A._0z8nYCJrlu%3Aafter%7Bborder-color%3Avar(--ds-border-brand%2C%231868db)%7D%0A._2nTuUYGaer%3Avisited%7Bcolor%3Avar(--ds-text-brand%2C%231868db)%7D%0A._10n1R5Gaer%3Afocus%7Bcolor%3Avar(--ds-text-brand%2C%231868db)%7D%0A._0clgaMGaer%3Ahover%7Bcolor%3Avar(--ds-text-brand%2C%231868db)%7D%0A._0CMRbkGaer%3Aactive%7Bcolor%3Avar(--ds-text-brand%2C%231868db)%7D%0A._1eOmH6NPoG%3Ahover%7Bbackground-color%3Avar(--ds-background-brand-subtlest-hovered%2C%23cfe1fd)%7D%0A._3gzVzLLKV0%3Aactive%7Bbackground-color%3Avar(--ds-background-brand-subtlest-pressed%2C%23adcbfb)%7D");


































































































































import React, { useRef } from 'react';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { cx } from '@atlaskit/css';
import mergeRefs from '@atlaskit/ds-lib/merge-refs';
import useAutoFocus from '@atlaskit/ds-lib/use-auto-focus';
import { useId } from '@atlaskit/ds-lib/use-id';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { SplitButtonContext } from '../../containers/split-button/split-button-context';
import { useSplitButtonContext } from '../../containers/split-button/use-split-button-context';
import { type Appearance, type CommonBaseProps, type CommonButtonProps, type Spacing } from '../types';
import blockEvents from './block-events';
import renderLoadingOverlay from './loading-overlay';
const LOADING_LABEL = ', Loading';
export type ControlledEvents<TagName extends HTMLElement> = Pick<React.DOMAttributes<TagName>, 'onMouseDownCapture' | 'onMouseUpCapture' | 'onKeyDownCapture' | 'onKeyUpCapture' | 'onTouchStartCapture' | 'onTouchEndCapture' | 'onPointerDownCapture' | 'onPointerUpCapture' | 'onClickCapture' | 'onMouseOver' | 'onMouseOut' | 'onMouseMove' | 'onFocus' | 'onBlur' | 'onMouseDown' | 'onMouseUp' | 'onKeyDown' | 'onKeyUp' | 'onTouchStart' | 'onTouchEnd' | 'onPointerDown' | 'onPointerUp'> & Pick<CommonButtonProps<TagName>, 'onClick'>;
type ButtonBaseProps<TagName extends HTMLElement> = CommonBaseProps & Pick<CommonButtonProps<TagName>, 'autoFocus' | 'isDisabled' | 'isSelected' | 'testId' | 'analyticsContext' | 'interactionName'> & {
  appearance?: Appearance;
  isLoading?: boolean;
  isIconButton?: boolean;
  isCircle?: boolean;
  hasIconBefore?: boolean;
  hasIconAfter?: boolean;
  shouldFitContainer?: boolean;
  spacing?: Spacing;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaLabel?: string;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaLabelledBy?: string;
  children: React.ReactNode;
  ref: React.Ref<TagName>;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  componentName?: string;
  // Private root styling slot for internal variants; not part of Button's public API.
  rootXcss?: React.ComponentProps<typeof Pressable>['xcss'];
  role?: string;
  iconButtonRef?: React.Ref<HTMLButtonElement>;
  tooltipRef?: React.Ref<HTMLButtonElement>;
  onMouseOver?: React.MouseEventHandler<HTMLButtonElement> | React.MouseEventHandler<TagName>;
  onMouseOutonMouseOver?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseMoveonMouseOver?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseDownonMouseOver?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseMove?: React.MouseEventHandler<HTMLButtonElement>;
  onFocus?: React.FocusEventHandler<HTMLButtonElement>;
  onBlur?: React.FocusEventHandler<HTMLButtonElement>;
  onClick?: ((e: React.MouseEvent<TagName>, analyticsEvent: UIAnalyticsEvent) => void) | undefined;
} & ControlledEvents<TagName>;
const styles = {
  base: "_0bjKvDKTcp _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
  interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
  linkDecorationUnset: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8",
  disabled: "_0wOv4Qsyl5 _1UtDYzot27 _0clgaMot27 _0CMRbkot27",
  sharedDisabled: "_0KLXruVrZW _1eOmH6VrZW _3gzVzLVrZW",
  spacingCompact: "_0bjKvDKxmn _4c065UFQfX _17lj8p1Y8M _0jFU0V9DVM _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV",
  circle: "_0bjKvDS5Zs",
  fullWidth: "_39xV02N91d",
  loading: "_0wOv4Q2mtD",
  iconButton: "_0jFU0VZ49V _39xV02Z49V _03SyCPPgdg _0LQT5EPgdg",
  iconButtonCompact: "_0jFU0V9DVM _39xV029DVM",
  buttonIconBefore: "_0LQT5E8HPE _17lj8pgVvo",
  buttonIconAfter: "_03SyCP8HPE _17lj8pgVvo",
  splitButton: "_13yjolgtVO",
  loadingOverlay: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT _1ZB6UyPgdg _2I62gzPgdg _1OKFqYPgdg _3iC0zdPgdg",
  navigationSplitButton: "_39xV02oWWg _0KLXru66of _03SyCPgVvo _0LQT5EgVvo"
};
const defaultStyles = {
  root: "_0KLXru66of _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _0clgaMZpcK _0CMRbkZpcK",
  interactive: "_1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK",
  disabled: "_0KLXrujOvk _0z8nYChQC5 _1eOmH6jOvk _3gzVzLjOvk"
};
const primaryStyles = {
  root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
  interactive: "_0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const rovoStyles = {
  root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
  interactive: "_0clgaMe5R3 _1eOmH63nEM _0CMRbke5R3 _3gzVzLjYGY"
};
const warningStyles = {
  root: "_0KLXruKLKE _1UtDYzVW6T _2nTuUYVW6T _10n1R5VW6T _0clgaMVW6T _0CMRbkVW6T",
  interactive: "_0clgaMVW6T _1eOmH6OCpk _0CMRbkVW6T _3gzVzLSN2W"
};
const dangerStyles = {
  root: "_0KLXruqsXs _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
  interactive: "_0clgaMe5R3 _1eOmH6EISo _0CMRbke5R3 _3gzVzLL5fL"
};
const discoveryStyles = {
  root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
  interactive: "_0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const subtleStyles = {
  root: "_0KLXru66of _1UtDYzZpcK _2nTuUYZpcK _10n1R5ZpcK _0clgaMZpcK _0CMRbkZpcK",
  interactive: "_1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK",
  disabled: "_0KLXrujOvk _0z8nYChQC5 _1eOmH6jOvk _3gzVzLjOvk"
};
const selectedStyles = {
  root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
  insideSplitButton: "_42Yu6BiZR3",
  interactive: "_1eOmH6sumd _0clgaMjTy9 _3gzVzLXsxn _0CMRbkjTy9",
  warning: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
  danger: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
  discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
};
const brandSelectedSplitButtonStyles = {
  root: "_0KLXrunl7T _1UtDYzGaer _0z8nYCJrlu _0GBAIrogpp _2nTuUYGaer _10n1R5Gaer _0clgaMGaer _0CMRbkGaer",
  interactive: "_1eOmH6NPoG _0clgaMGaer _3gzVzLLKV0 _0CMRbkGaer"
};

/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */
const ButtonBase: React.ForwardRefExoticComponent<React.PropsWithoutRef<ButtonBaseProps<HTMLButtonElement>> & React.RefAttributes<HTMLButtonElement>> = React.forwardRef(
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({
  appearance: propAppearance,
  autoFocus = false,
  isDisabled: propIsDisabled = false,
  isLoading = false,
  isSelected: propIsSelected = false,
  isIconButton = false,
  isCircle = false,
  hasIconBefore = false,
  hasIconAfter = false,
  shouldFitContainer = false,
  spacing: propSpacing = 'default',
  ariaLabel,
  ariaLabelledBy,
  children,
  interactionName,
  onClick,
  onMouseDown,
  onMouseDownCapture,
  onMouseUp,
  onMouseUpCapture,
  onKeyDown,
  onKeyDownCapture,
  onKeyUp,
  onKeyUpCapture,
  onTouchStart,
  onTouchStartCapture,
  onTouchEnd,
  onTouchEndCapture,
  onPointerDown,
  onPointerDownCapture,
  onPointerUp,
  onPointerUpCapture,
  onClickCapture,
  testId,
  analyticsContext,
  componentName,
  rootXcss,
  role,
  onMouseOver,
  onMouseOut,
  onFocus,
  onBlur,
  onMouseMove,
  type,
  ...unsafeRest
}: ButtonBaseProps<HTMLButtonElement>, ref: React.Ref<HTMLButtonElement>): JSX.Element => {
  // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
  'use no memo';

  const localRef = useRef<HTMLButtonElement | null>(null);
  const splitButtonContext = useSplitButtonContext();
  const loadingLabelId = useId();
  const isSplitButton = Boolean(splitButtonContext);
  const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
  const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
  const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
  const spacing = splitButtonContext?.spacing || propSpacing;
  const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
  const isInteractive = !isDisabled && !isLoading;
  // Also treat loading buttons as disabled
  const isEffectivelyDisabled = isDisabled || isLoading;
  const isSelected = propIsSelected && !isDisabled;
  // The open dropdown is part of a primary action, not a standalone selection.
  const isBrandSelectedSplitButton = isSelected && appearance === 'primary' && splitButtonContext?.appearance === 'primary' && fg('platform-dst-tokens-finesse');
  useAutoFocus(localRef, autoFocus);

  // @ts-expect-error
  const {
    className: _className,
    css: _css,
    as: _as,
    style: _style,
    ...saferRest
  } = unsafeRest;
  return <Pressable {...saferRest} componentName={componentName || 'button'} analyticsContext={analyticsContext} role={role} ref={mergeRefs([localRef, ref])} xcss={cx(styles.base, isInteractive && styles.interactiveMotion, appearance === 'default' && defaultStyles.root, appearance === 'default' && isInteractive && defaultStyles.interactive, appearance === 'primary' && primaryStyles.root, appearance === 'primary' && isInteractive && primaryStyles.interactive, appearance === 'rovo' && rovoStyles.root, appearance === 'rovo' && isInteractive && rovoStyles.interactive, appearance === 'warning' && warningStyles.root, appearance === 'warning' && isInteractive && warningStyles.interactive, appearance === 'danger' && dangerStyles.root, appearance === 'danger' && isInteractive && dangerStyles.interactive, appearance === 'discovery' && discoveryStyles.root, appearance === 'discovery' && isInteractive && discoveryStyles.interactive, appearance === 'subtle' && subtleStyles.root, appearance === 'subtle' && isInteractive && subtleStyles.interactive, styles.linkDecorationUnset, isSelected && selectedStyles.root, isSelected && isSplitButton && selectedStyles.insideSplitButton, isSelected && isInteractive && selectedStyles.interactive, isBrandSelectedSplitButton && brandSelectedSplitButtonStyles.root, isBrandSelectedSplitButton && isInteractive && brandSelectedSplitButtonStyles.interactive,
  // TODO: remove me once we kill color fallbacks
  isSelected && appearance === 'danger' && selectedStyles.danger,
  // TODO: remove me once we kill color fallbacks
  isSelected && appearance === 'warning' && selectedStyles.warning,
  // TODO: remove me once we kill color fallbacks
  isSelected && appearance === 'discovery' && selectedStyles.discovery, isDisabled && styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && styles.sharedDisabled, isDisabled && appearance === 'default' && defaultStyles.disabled, spacing === 'compact' && styles.spacingCompact,
  // This must come after spacing compact styling as it overrides the border radius
  isCircle && !isSplitButton && styles.circle, shouldFitContainer && styles.fullWidth, hasIconBefore && styles.buttonIconBefore, hasIconAfter && styles.buttonIconAfter, isIconButton && styles.iconButton, isIconButton && spacing === 'compact' && styles.iconButtonCompact, isLoading && styles.loading, isSplitButton && styles.splitButton, isNavigationSplitButton && styles.navigationSplitButton, rootXcss)} isDisabled={isDisabled} aria-live="polite" {...isLoading && {
    'aria-disabled': true
  }} aria-label={isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${LOADING_LABEL}` : ariaLabel} aria-labelledby={isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy} onClick={onClick} {...blockEvents(isEffectivelyDisabled, {
    onMouseDownCapture,
    onMouseUpCapture,
    onKeyDownCapture,
    onKeyUpCapture,
    onTouchStartCapture,
    onTouchEndCapture,
    onPointerDownCapture,
    onPointerUpCapture,
    onClickCapture
  })} testId={testId} onMouseOver={onMouseOver} onFocus={onFocus} onMouseMove={onMouseMove} onBlur={onBlur} type={type} interactionName={interactionName} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onKeyDown={onKeyDown} onMouseOut={onMouseOut} onKeyUp={onKeyUp} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} onPointerDown={onPointerDown} onPointerUp={onPointerUp}>
				<SplitButtonContext.Provider value={undefined}>
					{children}
					{isLoading && <span className={ax([styles.loadingOverlay])}>
							{renderLoadingOverlay({
          spacing,
          appearance,
          isDisabled,
          isSelected,
          testId
        })}
						</span>}
					{isLoading && (ariaLabelledBy || !ariaLabel) && <VisuallyHidden id={loadingLabelId}>{LOADING_LABEL}</VisuallyHidden>}
				</SplitButtonContext.Provider>
			</Pressable>;
});
export default ButtonBase;